<template lang="pug">
div(
    @mouseenter="openMiniCart"
    @mouseleave="delayCloseMiniCart"
    class="relative cursor-pointer"
)
    //- Shade for storyblok editor to prevent clicks
    div(
        v-if="$storyblok.isEditing"
        class="absolute inset-0 z-50"
    )

    div(@click="goToCheckout" class="flex justify-end")
        CartOutline(
            class="h-6 w-6 lg:h-7 lg:w-7 fill-current"
            :class="iconColorClass"
        )

        div(
            class="font-bold text-center absolute leading-none h-[18px] w-[18px] top-[-4px] right-[1px] lg:right-[2px]"
            :class="counterClass"
        ) {{ itemCount }}

    MiniCart(
        v-if="showMiniCart"
        class="z-40 absolute top-full right-0 m-1"
        style="width: 560px;"
    )
</template>

<script>
import MiniCart from '@/components/cart/miniCart'
import CartOutline from '@/assets/common/cartOutline?inline'
import { generateFontColorClass } from '~/integrations/storyblok/helpers'

export default {
    name: 'CartIconWidget',
    components: {
        MiniCart,
        CartOutline,
    },
    props: {
        data: {
            type: Object,
            default() {
                return {}
            },
        },
    },
    data() {
        return {
            showMiniCart: false,
            delayedClose: null,
        }
    },
    computed: {
        iconColorClass() {
            return generateFontColorClass(this.data?.iconColor)
        },
        counterClass() {
            return [
                generateFontColorClass(this.data?.countColor),
                this.itemCount >= 10 ? 'text-sm' : '',
            ]
        },
        itemCount() {
            return this.$store.state.cart.data.itemCount || 0
        },
    },
    watch: {
        $route() {
            if (this.showMiniCart) {
                this.closeMiniCart()
            }
        },
    },
    methods: {
        goToCheckout() {
            this.$push.to({ name: 'cart' })
        },
        openMiniCart() {
            if (this.$device.isSmall || !this.itemCount || this.$route.meta.hideMiniCart) return
            clearTimeout(this.delayedClose)
            if (this.showMiniCart) return
            this.showMiniCart = true
        },
        closeMiniCart() {
            this.showMiniCart = false
        },
        delayCloseMiniCart(e) {
            // The e.relatedTarget is an IE 11 fix. when you change an item qty IE 11 triggers mouseleave.
            // this will simply escape the function so the minicart won't close when changing the item qty
            if (this.$device.isSmall || !e.relatedTarget || this.$route.meta.hideMiniCart) return
            clearTimeout(this.delayedClose)
            if (!this.showMiniCart) return
            this.delayedClose = setTimeout(() => {
                this.closeMiniCart()
            }, 700)
        },
    },
}
</script>
